import { MouseEvent } from 'react';

import { getPage } from 'shared/api/event-service';
import { PAGES } from 'shared/config/constants';
import { dateService } from 'shared/lib/date';

export const getRecommendationEventContextExtension = (
  e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  domains: string | Record<string, string>,
) => {
  return {
    url: window.location.href,
    page: getPage(),
    isRightClick: e.type === 'contextmenu',
    section:
      getPage() === PAGES.RECOMMENDATIONS ? undefined : PAGES.RECOMMENDATIONS,
    product: typeof domains === 'object' ? Object.values(domains)[0] : domains,
  };
};

// consider data stale if week when it has been stored is gone
export const checkInsightsCacheIsStale = (cachedDataTimestamp: number) => {
  const nowTimestamp = dateService
    .getDayJSObject()
    .tz('America/New_York')
    .valueOf();

  const endOfWeekCachedData = dateService
    .getDayJSObject(cachedDataTimestamp)
    .endOf('isoWeek')
    .valueOf();

  return nowTimestamp > endOfWeekCachedData;
};
